// extracted by mini-css-extract-plugin
export default {"icon":"AddTabButton_icon__iq528","option-list-container":"AddTabButton_option-list-container__bZJPk","optionListContainer":"AddTabButton_option-list-container__bZJPk"};